/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import { SOCIAL_NETWORKS, BASE_CLASS_NAME_FOLLOW } from './sf.config';
import BlazeLink from '../BlazeLink';

const SFItem = ({ url, id }) => {
  const { name, className, Icon, spanClassName } = SOCIAL_NETWORKS[id];

  return (
    <li className={BASE_CLASS_NAME_FOLLOW}>
      <BlazeLink
        href={url}
        className={className}
        rel="noopener nofollow"
        target="_blank"
        ariaLabel={name}>
        <i>
          <Icon />
        </i>
        <span className={`social__network ${spanClassName}`}>{name}</span>
      </BlazeLink>
    </li>
  );
};

SFItem.propTypes = {
  url: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

export default SFItem;
